interface AgencyLogoProps {
  width?: number;
  height?: number;
  title?: string;
}

const AgencyLogo = ({
  width = 33,
  height = 36,
  title = 'HireMe',
}: AgencyLogoProps) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    width={width}
    height={height}
    viewBox="0 0 33 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={title}
  >
    <path
      d="M33 28.2965H26.1738C26.1738 22.9917 21.8341 18.6759 16.5 18.6759C11.1659 18.6759 6.82625 22.9917 6.82625 28.2965H0C0 19.2481 7.40157 11.8871 16.5 11.8871C25.5984 11.8871 33 19.2481 33 28.2965Z"
      fill="var(--agency-navy)"
    />
    <path d="M6.82625 0H0V36H6.82625V0Z" fill="var(--agency-navy)" />
    <path d="M33 0H26.1737V36H33V0Z" fill="var(--agency-navy)" />
  </svg>
);

export default AgencyLogo;
